import React from 'react'
import Pproject from '../Component/Pproject'
import ClientTestimonial from '../Component/ClientTestimonial'
import { motion } from "framer-motion";
const Portfolio = () => {
  return (
    <>
        <div className="absolute left-[10%] top-[25%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#ff6572] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[10%] top-[25%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#ff6572] opacity-20 blur-[150px] rounded-full z-0"></div>

        {/* Bottom Pink Blobs */}
        <div className="absolute left-[15%] bottom-[10%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#e308a2] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[15%] bottom-[10%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#e308a2] opacity-20 blur-[150px] rounded-full z-0"></div>

        {/* Top Green Blobs */}
        <div className="absolute left-[50%] top-[5%] transform -translate-x-1/2 w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#70b616] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[50%] top-[5%] transform translate-x-1/2 w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#70b616] opacity-20 blur-[150px] rounded-full z-0"></div>

          <motion.div
        className="flex items-center justify-center mt-15"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1 }}
      >
        <motion.button
          className="bg-[#432DD7] text-[20px] font-[Nunito] text-white p-4 w-[185px] rounded-full"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          Our Work
        </motion.button>
      </motion.div>

      {/* Headings */}
      <motion.p
        className="md:text-[64px] text-[30px] font-[700] text-center relative"
        style={{ fontFamily: "PT Sans" }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1, delay: 0.3 }}
      >
        Showcasing Our Creative Solutions
      </motion.p>

      <motion.p
        className="md:text-[64px] text-[30px] font-[400] text-center font-[Allison] text-[#432DD7] relative"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        with innovation, strategy, and design excellence.
      </motion.p>
<br />
      <motion.p
        className="md:text-[24px] text-[16px] font-[500] font-[Nunito] text-center"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1, delay: 0.7 }}
      >
        Explore our portfolio of innovative digital solutions that have helped businesses transform
      </motion.p>

      <motion.p
        className="md:text-[24px] text-[16px] font-[500] font-[Nunito] text-center"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1, delay: 0.9 }}
      >
        and grow in the digital landscape.
      </motion.p>
    <br /><br /><br /><br />
            <Pproject/>
            <ClientTestimonial/>
    </>
  )
}

export default Portfolio
